"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareFaucet = void 0;
var React = require("react");
var SquareFaucet = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#00242D' : _b;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("defs", null,
            React.createElement("path", { d: "M13,16 C13,14.1 16,11 16,11 C16,11 19,14.1 19,16 C19,17.9 17.5,19 16,19 C14.5,19 13,17.9 13,16 Z M5,4 L19,4 C19.6,4 20,4.4 20,5 L20,8 C20,8.6 19.6,9 19,9 L9,9 L9,19 C9,19.6 8.6,20 8,20 L5,20 C4.4,20 4,19.6 4,19 L4,5 C4,4.4 4.4,4 5,4 Z", id: "SQUARE_FAUCET_path-1" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "SQUARE_FAUCET_mask-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#SQUARE_FAUCET_path-1" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#SQUARE_FAUCET_mask-2)", fill: color },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.SquareFaucet = SquareFaucet;
//# sourceMappingURL=SquareFaucet.js.map